/**
 * Design tokens — single source for premium 2026 dark cybersecurity UI.
 * MUI theme in App.js maps these into palette/components; pages import for sx-only polish.
 */
export const tokens = {
  bg: {
    app: '#07111F',
    sidebar: '#081221',
    card: '#0D1B2A',
    cardElevated: '#102033',
  },
  text: {
    primary: '#E6EDF7',
    secondary: '#93A4BD',
    muted: 'rgba(230, 237, 247, 0.7)',
  },
  border: {
    subtle: 'rgba(148, 163, 184, 0.18)',
    strong: 'rgba(148, 163, 184, 0.28)',
  },
  accent: {
    cyan: '#22D3EE',
    safe: '#22C55E',
    warning: '#F59E0B',
    danger: '#EF4444',
    insight: '#A78BFA',
    brandTeal: '#18B89A',
    brandBlue: '#3B82F6',
  },
  radius: {
    card: 22,
    control: 11,
  },
  /** 8px grid: n → px string */
  space: (n) => `${n * 8}px`,
  hero: {
    gradient:
      'linear-gradient(118deg, #102033 0%, rgba(34, 211, 238, 0.08) 36%, rgba(7, 17, 31, 0.35) 68%, rgba(7, 17, 31, 0.92) 100%)',
    border: '1px solid rgba(148, 163, 184, 0.22)',
    shadow: '0 12px 40px rgba(2, 6, 23, 0.55)',
  },
  filterWell: 'rgba(22, 35, 58, 0.95)',
  risk: {
    highBg: 'rgba(239, 68, 68, 0.14)',
    mediumBg: 'rgba(245, 158, 11, 0.16)',
    lowBg: 'rgba(34, 197, 94, 0.14)',
  },
  chart: {
    grid: 'rgba(148, 163, 184, 0.12)',
    axis: 'rgba(148, 163, 184, 0.55)',
    tooltipBg: '#102033',
    tooltipBorder: 'rgba(148, 163, 184, 0.28)',
    tooltipLabel: '#E6EDF7',
    barPrimary: '#22D3EE',
    barSecondary: '#3B82F6',
  },
  /** MUI `spacing` units for dashboard vertical rhythm */
  layout: {
    sectionMb: 3,
    containerPy: { xs: 3, md: 5 },
    containerPb: 6,
  },
};

export default tokens;
